import React from 'react';

const AddressLookup = ({
  handleChange,
  placeholder = 'Placeholder Text',
  label = '',
  name,
  onBlur,
  className = '',
  value,
  type = 'text',
  addresses = [],
  handleAddressClick,
}) => {
  const onChange = (e) => {
    if (handleChange instanceof Function) handleChange(e.target.value);
  };

  const hasSuggestions = addresses.length > 0;

  return (
    <>
      <label
        className={`u-weight--semibold ${
          !label.length && label.length < 1 ? 'u-hidden' : ''
        }`}
        htmlFor={name}
      >
        {label || name}
      </label>

      <input
        className="c-form__input c-form__input--secondary "
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      />

      {hasSuggestions && (
        <ul className="c-form__address-lookup__address-container">
          {addresses.map((address) => (
            <li
              className="c-form__input c-form__address-lookup__address"
              onClick={() => handleAddressClick(address)}
              key={`address-${address.id}`}
            >
              {address.address}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default AddressLookup;
